export default __webpack_public_path__ + "static/media/tela_livewatch.979fc602.png";